import { render, staticRenderFns } from "./PartnersPzge.vue?vue&type=template&id=732d3949&scoped=true"
import script from "./PartnersPzge.vue?vue&type=script&lang=js"
export * from "./PartnersPzge.vue?vue&type=script&lang=js"
import style0 from "./PartnersPzge.vue?vue&type=style&index=0&id=732d3949&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732d3949",
  null
  
)

export default component.exports